import { useState } from "react";

interface TopikImageProps {
    src: string;
    alt: string;
    className?: string;
}

function TopikImage({ src, alt, className = '' }: TopikImageProps) {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);

    return (
        <div className={`topik-image ${className}`}>
            {!imageLoaded && !imageError && (
                <div className="image-placeholder">
                    <div className="loading-spinner"></div>
                </div>
            )}
            {imageError && (
                <div className="image-error">
                    <span>Failed to load image</span>
                </div>
            )}
            <img
                src={src}
                alt={alt}
                onLoad={() => setImageLoaded(true)}
                onError={() => setImageError(true)}
                style={{ display: imageLoaded ? 'block' : 'none' }}
            />
            {imageLoaded && <a href="#CTA" onClick={(e)=>{e.preventDefault()}}><img
                src={'https://static.koreanmate.app/product/topik-250725/MATE_TOPIK2_class_cta.png'}
                alt={`TOPIK 250725 Detail Page cta`}
                onClick={()=>{window.scrollTo({top: window.document.body.scrollHeight, behavior: 'smooth'})}}
                className="cta-image"
            /></a>}
        </div>
    );
}

export default TopikImage;